export function initProductListing() {
    window.mergeAdjacentCollections = (e) => {
        const collectionContainers = document.querySelectorAll('.collection--container');
        if (collectionContainers.length < 2) return;

        for (let i = 0; i < collectionContainers.length - 1; i++) {
            const container = collectionContainers[i];
            const nextContainer = collectionContainers[i + 1];
            
            if (container.dataset.collectionName !== nextContainer.dataset.collectionName) continue;
            
            const nextItems = nextContainer.querySelectorAll('.collection--items');
            nextItems.forEach(x => container.appendChild(x));
            nextContainer.remove();
        }
    };

    const mainForm = document.getElementById("tmp-product-category-facets-form");
    const mobileForm = document.getElementById("tmp-product-category-facets-form-mobile");
    const modal = document.getElementById("facetsModal");
    if (!mainForm || !mobileForm || !modal) return;

    const openBtn = document.querySelector(".tmp-productcategory__facets-filter");
    const closeBtn = modal.querySelector(".tmp-productcategory__facets-modal__close");
    const overlay = modal.querySelector(".tmp-productcategory__facets-modal__overlay");

    // start accordiong & helpers
    function toggleAccordion(button, values) {
        const expandIcon = button.querySelector(".accordion-icon__expand");
        const collapseIcon = button.querySelector(".accordion-icon__collapse");
        const isHidden = values.hasAttribute("hidden");
        if (isHidden) {
            values.removeAttribute("hidden");
            button.classList.add("open");
            expandIcon.setAttribute("hidden", "");
            collapseIcon.removeAttribute("hidden");
        } else {
            values.setAttribute("hidden", "");
            button.classList.remove("open");
            collapseIcon.setAttribute("hidden", "");
            expandIcon.removeAttribute("hidden");
        }
    }

    function openModal() {
        modal.classList.add("is-open");
        document.body.style.overflow = "hidden";
    }
    function closeModal() {
        modal.classList.remove("is-open");
        document.body.style.overflow = "";
    }

    openBtn?.addEventListener("click", openModal);
    closeBtn?.addEventListener("click", closeModal);
    overlay?.addEventListener("click", closeModal);

    document.querySelectorAll("[data-accordion-toggle]").forEach(button => {
        button.addEventListener("click", () => {
            const values = button.nextElementSibling;
            toggleAccordion(button, values);
        });
    });
    // end accordion & helpers


    // helper function to update the facet count badge
    function updateFacetCountFor(groupEl) {
        const count = groupEl.querySelectorAll('.facet-checkbox:checked').length;
        const badge = groupEl.querySelector('[data-facet-count]');
        const btn = groupEl.querySelector('.tmp-productcategory__facets__group-accordion p');

        if (!badge) return;
        if (count > 0) {
            badge.textContent = String(count);
            badge.setAttribute('data-facet-count', String(count));
            badge.removeAttribute('hidden');
            btn.classList.add("bold");
        } else {
            badge.textContent = '';
            badge.setAttribute('data-facet-count', '0');
            badge.setAttribute('hidden', '');
            btn.classList.remove("bold");
        }
    }

    // update facet count when user clicks a facet
    mainForm.addEventListener("change", (e) => {
        const cb = e.target;
        if (!(cb instanceof HTMLInputElement)) return;
        if (!cb.classList.contains("facet-checkbox")) return;
        updateFacetCountFor(cb.closest(".tmp-productcategory__facets__group"));
        mainForm.requestSubmit();
    });

    // update facet count when user clicks a facet
    mobileForm.addEventListener("change", (e) => {
        const cb = e.target;
        if (!(cb instanceof HTMLInputElement)) return;
        if (!cb.classList.contains("facet-checkbox")) return;
        updateFacetCountFor(cb.closest(".tmp-productcategory__facets__group"));
        const id = cb.closest(".tmp-productcategory__facets__group")?.getAttribute("data-accordion-id");
        if (id) {
            const desktopGroup = document.querySelector(`.tmp-productcategory__facets__groups-desktop .tmp-productcategory__facets__group[data-accordion-id="${id}"]`);
            if (desktopGroup) updateFacetCountFor(desktopGroup);
        }
        syncCheckboxes(mobileForm, mainForm);
        mainForm.requestSubmit();
        closeModal();
    });

    const resetDesktopBtn = document.getElementById("reset-facets");
    resetDesktopBtn?.addEventListener("click", () => {
        mainForm.querySelectorAll(".facet-checkbox").forEach(cb => cb.checked = false);
        document.querySelectorAll(".tmp-productcategory__facets__group").forEach(updateFacetCountFor);
        mainForm.requestSubmit();
    });

    const resetMobileBtn = document.getElementById("reset-facets-mobile");
    resetMobileBtn?.addEventListener("click", () => {
        mobileForm.querySelectorAll(".facet-checkbox").forEach(cb => cb.checked = false);
        syncCheckboxes(mobileForm, mainForm);
        document.querySelectorAll(".tmp-productcategory__facets__group").forEach(updateFacetCountFor);
        mainForm.requestSubmit();
        closeModal();
    });

    function syncCheckboxes(sourceForm, targetForm) {
        targetForm.querySelectorAll(".facet-checkbox").forEach(desktopCb => {
            const sourceCb = sourceForm.querySelector(
                `.facet-checkbox[name="${desktopCb.name}"][value="${desktopCb.value}"]`
            );
            if (sourceCb) desktopCb.checked = sourceCb.checked;
        });
    }
    
    mobileForm.querySelectorAll(".sort-radio").forEach(rb => {
        rb.addEventListener("change", () => {
            const select = mainForm?.querySelector("select[name='SortOrder']");
            if (select) {
                select.value = rb.value;
                select.dispatchEvent(new Event("change", { bubbles: true }));
            }

            const sortLabel = document.getElementById("sortLabel");
            if (sortLabel) {
                sortLabel.textContent = rb.value;
            }
            closeModal();
        });
    });

    // update facet count on initial paint
    document.querySelectorAll(".tmp-productcategory__facets__group").forEach(updateFacetCountFor);

    // render error msg on htmx failure
    const plpRoot = document.querySelector('.tmp-productcategory');

    if (plpRoot) {
        plpRoot.addEventListener('htmx:responseError', function () {
            var err = document.getElementById('plp-error');
            if (err) err.classList.remove('hidden');
        });
        plpRoot.addEventListener('htmx:afterSwap', function () {
            var err = document.getElementById('plp-error');
            if (err) err.classList.add('hidden');
        });
    }

    // after user interacts with applied facet chips, set checkbox val to false and dispatch change event
    function onAppliedFacetClick(e) {
        const btn = e.target.closest('.tmp-productcategory__facets__applied-chips');
        if (!btn) return;

        const key = btn.dataset.facetKey;
        const val = btn.dataset.facetValue;
        if (!key || !val) return;

        const cb = mainForm.querySelector(`input.facet-checkbox[name="filters[${key}]"][value="${CSS.escape(val)}"]`);
        if (!cb || !cb.checked) return;

        cb.checked = false;
        cb.dispatchEvent(new Event('change', { bubbles: true }));
    }

    function bindAppliedFacetClicks() {
        const applied = document.getElementById('applied-facets');
        if (!applied) return;

        // Guard against accidental double-bind
        applied.removeEventListener('click', onAppliedFacetClick);
        applied.addEventListener('click', onAppliedFacetClick);
    }

    // Initial bind
    bindAppliedFacetClicks();

    // Re-bind after HTMX swaps
    document.body.addEventListener('htmx:oobAfterSwap', (e) => {
    const target = e.detail?.target;
    if (target && target.id === 'applied-facets') {
        bindAppliedFacetClicks();
    }
    });

}